import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'icon-excel',
  templateUrl: './excel.component.html',
  styleUrls: ['./excel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExcelComponent {}
